import { CircularProgress } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }),
);

export const LoadingInterceptor = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: any;
}) => {
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.container}>
        <CircularProgress />
      </div>
    );
  }

  return children;
};
